const ROLE_ADMIN: string = 'ROLE_ADMIN';

export { ROLE_ADMIN };
